import { COMPACT_UNITS } from './amount.content';

export const formatNumber = (
  value: number,
  options?: Intl.NumberFormatOptions,
) => new Intl.NumberFormat('en-US', options).format(value);

export const formatCompact = (value: number) => {
  const direction = value < 0 ? -1 : 1;

  let unitIndex = 0;
  let _value = Math.abs(value);

  while (_value >= 1000 && unitIndex < COMPACT_UNITS.length - 1) {
    _value /= 1000;
    unitIndex++;
  }

  const formattedValue = Math.floor(_value * direction * 10) / 10;

  return formattedValue + COMPACT_UNITS[unitIndex];
};

export const formatAmount = (amount: number) =>
  formatNumber(amount, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
